"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayNumber = exports.capitalizeFirstLetter = void 0;
function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
exports.capitalizeFirstLetter = capitalizeFirstLetter;
function displayNumber(n) {
    var value = parseFloat(n.toString());
    if (isNaN(value))
        return "";
    return n.toString();
}
exports.displayNumber = displayNumber;
